<div class="full bg-background">
  <app-operation-material-mapping-detail
    class="flex"
    [operationSegmentSpec]="copy"
    (close)="onClose($event)"
    (save)="onSave($event)"
  >
  </app-operation-material-mapping-detail>
</div>
